import { render, staticRenderFns } from "./Dispatcher.vue?vue&type=template&id=7871b054"
import script from "./Dispatcher.vue?vue&type=script&lang=js"
export * from "./Dispatcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports